import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { AccessCode, VerifyEmailCode } from '../../login/two-factor-authentication/interface/two-factor-authentication.interface';
import { CommonService } from './app.common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { first } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { JTUserIdleService } from '../userIdle/user-idle.service';

@Injectable()
export class TwoFactorAuthenticationService {
  public _baseUrl;
  private appUrl: string;
  private serviceUrl = environment.LoginUrl;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS', 'Access-Control-Allow-Headers': '*' });

  private options = { headers: this.headers };

  constructor(private common: CommonService, public authService: AuthenticationService, private userIdle: JTUserIdleService ,private http: HttpClient, @Inject('BASE_URL') baseUrl: string,

  ) {
    this._baseUrl = baseUrl + "api/";

    if (environment.production)
      this.appUrl = this._baseUrl;
    else
      this.appUrl = this.serviceUrl;
  }
  verifyCode(verifyCodeData: AccessCode, callback?: any) {
    var $this = this;
    this.http
      .post(this.appUrl + this.common.ApiUrls.Login.VerifyCode, JSON.stringify(JSON.stringify(verifyCodeData)), this.options).pipe(first()).subscribe(data => {
        var res = data;
        callback(res);
      });
  }
  emailCode(callback?: any) {
    var $that = this;
    this.common.Loader.show();
    this.http
      .get(this.appUrl + this.common.ApiUrls.TwoFactorAuthentificatoin.EmailCode, this.options).pipe(first()).subscribe(data => {
        var res = data;
        $that.common.Loader.hide();
        callback(res);
      });
  }

  verifyEmailCode(objVerifyEmailCode: VerifyEmailCode, callback?: any) {
    var $that = this;
    this.common.Loader.show();
    this.http
      .post(this.appUrl + this.common.ApiUrls.TwoFactorAuthentificatoin.VerifyEmailCode, objVerifyEmailCode, this.options).pipe(first()).subscribe(data => {
        var res = data;
        $that.common.Loader.hide();
        callback(res);
      });
  }

  getQrCode(callback?: any) {
    var $that = this;
    this.common.Loader.show();
    this.http
      .post(this.appUrl + this.common.ApiUrls.TwoFactorAuthentificatoin.GetQrCode, this.options).pipe(first()).subscribe(data => {
        var res = data;
        $that.common.Loader.hide();
        callback(res);
      });
  }

  getSecurityRole(callback:any, isNavigate = true) {
    this.common.RemoveLocalStorage("QuickLinks");
    this.userIdle.startWatching();
    this.userIdle.resetTimer();
    this.authService.GetOwnSecurityRole(callback, isNavigate)
  }

}
